import { DetailCards, LeaveBadges } from "../payroll/DetailCards";
import { AL } from "./attReportLabels";

// تفاصيل الحضور داخل الصفحة بنفس أعمدة تقرير الحضور المطبوع.
export const AttendanceDetails = ({ data, lang }) => {
  const L = AL[lang === "en" ? "en" : "ar"];
  const t = data.totals;
  return (
    <div className="grid gap-4" data-testid="attendance-details">
      <DetailCards
        items={[
          [L.cards[0], t.employees],
          [L.cards[1], t.days_worked],
          [L.cards[2], t.absence_days, t.absence_days ? "bad" : "good"],
          [L.cards[3], t.late_count, t.late_count ? "bad" : "good"],
        ]}
      />
      <div className="overflow-x-auto">
        <table className="w-full min-w-[720px] text-start text-xs">
          <thead>
            <tr className="bg-primary/10">
              {L.cols.map((col) => (
                <th key={col} className="px-2 py-2 text-start text-[10px] font-bold text-primary">{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.employees.map((e) => (
              <tr key={e.employee_name + e.branch_name} className="border-b border-border/30"
                  data-testid={`attendance-detail-row-${e.employee_name}`}>
                <td className="px-2 py-2">
                  <span className="font-bold">{e.employee_name}</span>
                  <span className="block text-[10px] text-muted-foreground">{e.branch_name}</span>
                </td>
                <td className="px-2 py-2 font-mono font-bold">{e.days_worked}</td>
                <td className={`px-2 py-2 font-mono ${e.absence_days ? "text-destructive font-bold" : ""}`}>
                  {e.absence_days}
                  {e.absence_dates?.length ? (
                    <span className="block text-[9px] text-destructive/80">
                      {e.absence_dates.slice(0, 5).join(", ")}{e.absence_dates.length > 5 ? " …" : ""}
                    </span>
                  ) : null}
                </td>
                <td className={`px-2 py-2 font-mono ${e.late_count ? "text-destructive font-bold" : ""}`}>
                  {e.late_count}
                </td>
                <td className="px-2 py-2">
                  {e.leave_days} <LeaveBadges breakdown={e.leave_breakdown} labels={L.leaveTypes} />
                </td>
                <td className="px-2 py-2 font-mono font-bold">{e.total_weekends}/{e.paid_weekends}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
